import {FirstAidKitItem} from "../Model/FirstAidKitData";
import {useContext, useEffect, useState} from "react";
import FirstAidKitManager from "../FirstAidKitManager";
import Footer from "../../Shared/Components/Footer";
import ThemeContext from "../../Shared/Theme/ThemeContext";
import {GameHint} from "../../Quiz/Components/GameHint";
import Score, {ScoreData} from "../../Shared/Components/Score";
import FirstAidKitItemMove from "./FirstAidKitItemMove";
import useSound from "use-sound";
import Button from "../../Shared/Components/Button";


export interface FirstAidKitGameProps {
    title: string,
    subtitle: string
    items: [FirstAidKitItem]
    onFinish: (score: ScoreData) => void
    onCancel: () => void
}

export interface FirstAidKitMoveItemProps {
    droppedCorrectly: number[]
    droppedIncorrectly: number[]
    onItemDropped: (id, source_id, correct, explanation) => void
    items: FirstAidKitItem[]
    itemsCounting: string
    itemsHidden: string[]
    isFinished: boolean
}


export default function FirstAidKitPlay(props: FirstAidKitGameProps) {
    const theme = useContext(ThemeContext)
    const [manager,] = useState<FirstAidKitManager>(() => new FirstAidKitManager(props.items))

    const [itemsCounting, setItemsCounting] = useState<string>("")
    const [itemsCorrect, setItemsCorrect] = useState<FirstAidKitItem[]>([])
    const [itemsHidden, setItemsHidden] = useState<string[]>([])
    const [isFinished, setIsFinished] = useState<boolean>(undefined)
    const [isCorrect, setIsCorrect] = useState<boolean>(undefined)
    const [explanation, setExplanation] = useState("Przeciągnij do apteczki te przedmioty, które powinieneś zapakować wybierając się na wędrówkę!")

    const [soundGood] = useSound("sounds/good.mp3")
    const [soundWrong] = useSound("sounds/wrong.mp3")

    const itemDropped = (id: number, source_id: string, correct: boolean, explanation: string) => {
        if (correct) {
            let hidden = itemsHidden
            hidden.push(source_id)
            setItemsHidden(hidden)
        }

        setIsCorrect(correct)
        setExplanation(explanation)
        setItemsCounting(countingText())
        scrollToTop()

        if (correct) { soundGood() } else { soundWrong() }

        if (itemsHidden.length >= itemsCorrect.length) {
            setIsFinished(true)
        }
    }

    const countingText = () => {
        return itemsHidden.length + "/" + itemsCorrect.length
    }

    const scrollToTop = () => {
        window.scrollBy({ top: 0 })
        const div = document.querySelector('.quiz-hint.top')
        let position = div.getBoundingClientRect()
        window.scrollTo(position.left, position.top + window.scrollY - 20);
    }

    useEffect(() => {
        setItemsCounting(countingText())
    }, [itemsHidden])

    useEffect(() => {
        setItemsCorrect(props.items.filter(item => item.isCorrect == true))
        setItemsHidden([])
    }, [])

    return <div className={"first-aid-kit play"} style={{backgroundImage:'url('+theme.backgroundImage+')'}}>

        <h1>{props.title}</h1>
        <GameHint className="top" text={explanation} isCorrect={isCorrect}  />

        <div className={"task"}>
            <FirstAidKitItemMove
                isFinished={isFinished}
                itemsHidden={itemsHidden}
                itemsCounting={itemsCounting}
                droppedCorrectly={[]}
                droppedIncorrectly={[]}
                onItemDropped={(id, source_id, correct, explanation) => {
                    itemDropped(id, source_id, correct, explanation)
                }} items={props.items}
            />
            {isFinished &&
            <div className={"summary"}>
                <h1>Gotowe!</h1>
                <p>Mamy skompletowaną apteczkę. Kliknij i przypomnij sobie co powinieneś do niej spakować!</p>
                <Button
                    color={"default"}
                    title={"PODSUMOWANIE"}
                    onClick={() => { props.onFinish(manager.score()) }}
                />
            </div>
            }
        </div>

        <Score data={manager.score()}/>
        <Footer home={props.onCancel}/>
    </div>
}